<template>
	<div class="body">
		<div class="bg_1">
			<div class="nav-class" style="position: relative;">
				<div @click="selectFun(index)" v-for="(item,index) in tabs" :key="index" class="div_">
					<div :class="{active:acitveIndex===index}">{{item}}</div>
					<div class="div_2" :class="{line:acitveIndex===index}"> </div>
				</div>

			</div>
			<div class="line_1"></div>
			<el-input placeholder="请输入内容" v-model="page.title" class="input-with-select">

				<el-button slot="append" type="text" class="ss" @click="butFun">搜索</el-button>
			</el-input>
			<div class="i-items" v-if="dataList.length>0">
				<div class="i-item" v-for="(item,index) in dataList" :key="index" @click="toUrl(item)">
					<div class="i-title">{{item.title}}</div>
					<div class="i-content">
						<span>发文单位：</span>
						<span>{{item.unitType}}</span>
					</div>
					<div class="i-footer">
						<span>{{item.publishedTime && item.publishedTime.substring(0,10)}}</span>
						<span class="i-footer-date">{{item.documentNo}}</span>
					</div>
					<!-- <div class="i-footer-date">
						<span>{{item.publishedTime}}</span>
					</div> -->
					<div class="line_"></div>
				</div>
			</div>
			<el-empty v-else description="暂无数据"></el-empty>
			<el-pagination background v-show="total" :pager-count=5 layout="prev, pager, next"
				:current-page.sync="page.pageNum" :page-size.sync="page.pageSize" @current-change="getList"
				:total="total">
			</el-pagination>


		</div>

	</div>
</template>

<script>
import {
	policyList
} from '@/api/api.js';

export default {
		beforeCreate() {
		document.querySelector('body').setAttribute('style', 'margin:0;')
	},
	data() {
		return {
			index: 0,
			tabs: [
				"专项政策", "综合政策",
			],
			page: {
				pageSize: 5,
				pageNum: 1,
				type: 1,
				title: ""
			},
			total: 0,
			acitveIndex: 0,
			dataList: [],

		}
	},
	created() {
		this.getList()
	},
	methods: {
		toUrl(item) {
			window.open(item.url);
		},
		butFun() {
			this.getList()
		},
		getList() {
			policyList(this.page).then(res => {
				window.scrollTo(0, 0);
				this.dataList = res.rows
				this.total = res.total
				console.log(res)
			})
		},
		//切换列表
		selectFun(index) {
			this.total = 0
			this.acitveIndex = index
			this.page.pageNum = 1
			this.page.type = index + 1
			this.dataList = []
			this.getList()
		},

	}
}
</script>

<style  >
body {
	background: #fff !important;
		margin-top: -2rem!important;
		border: none;
}

.nav-class {
	display: flex;
	justify-content: space-around;
	align-items: center;
	height: 2.2rem;
	padding: 0 .9375rem;

	background-color: #fff;
	font-size: .9375rem;
	font-weight: 600;
    color: #939393;
	z-index: 999;

}
.line_1{
	height: 1px;
    background: #F5F5F7;
}
.ss {
	padding: 0 .9375rem !important;
	font-size: .875rem !important;
	font-weight: 400;
	color: #2882FD !important;
	position: relative;
	top: .0625rem;
}

.div_ {
	position: relative;
	display: inline-block;
	/* width: 4.6875rem; */
	height: 100%;
}

.div_2 {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);

}

.input-with-select {
	box-sizing: border-box;
	margin: .9375rem 0;
		padding: 0 .9375rem;
}

.bg_1 {
	padding-bottom: .9375rem;
}

.active {

	font-weight: 600;
    color: #2882FD;
}

.line {
	width: 1.875rem;
	height: .125rem;
	background: #2882FD;
	border-radius: 1px;
	margin: 0 auto;
}

.i-item {
	text-align: left;
	margin-top: 0.25rem;
	padding: 0 .9375rem;
}

.i-title {

	font-size: .9375rem;
	font-family: PingFang SC;
	font-weight: 600;
	color: #161515;

}

.i-content {
	font-size: .8125rem;
	font-weight: 500;
	color: #9F9F9F;
	margin-top: 0.5rem;
}

.i-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: .8125rem;
	font-weight: 500;
	color: #9F9F9F;
	margin-top: 1rem;
}

.i-footer-date {
	position: relative;
	top: -.0625rem;
	width: 10rem;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	text-align: end;

}

.line_ {
	width: 100%;
	height: .125rem;
	background: #F5F5F7;
	margin: .9375rem 0;
}

.el-pager li {
	margin: 0 .15625rem !important;
}

.el-pagination {
	display: flex;
	justify-content: center;
	padding: 2px .15625rem !important;
}

.el-input__inner {
	height: 2.5rem !important;
}

.el-input-group__append {
	padding: 0 1.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/index_3.vue